<template>
  <el-dialog :title="title" :visible.sync="domVisible" custom-class="changePhone" :lock-scroll="false" :before-close="handleClose" v-loading="loading">
    <div class="accountBox">
      <el-form class="register_box" :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item class="login_form_item account" prop="Account">
          <!-- <div class="AreaCode" v-if="ruleForm.Type=='1'">+1</div> -->
          <!-- 国籍 -->
          <div class="locationPhoneBox" v-if="ruleForm.Type=='1'">
            <div class="countries" v-if="ruleForm.MemberSource!=''">
              <img :src="ruleForm.LocationIcon" alt="">
            </div>
            <el-select class="login_ipt" :class="ruleForm.MemberSource!=''?'nolocation':''" placeholder="" v-model="ruleForm.MemberSource" popper-class='location' @change='changeLocation'>
              <el-option class="locationelOption" :label="item.EnName" :value="item.Code" v-for="(item,index) in locationOption" :key='index'>
                <div class="locationOption">
                  <img :src="item.IconUrl">
                  <span>{{item.EnName}}</span>
                </div>
              </el-option>
            </el-select>
            <div class="nationCode">
              {{ruleForm.AreaCode}}
            </div>
          </div>
          <el-input class="login_ipt first_login_ipt" :class="{'email':ruleForm.Type=='1'}" v-model="ruleForm.Account" :placeholder="ruleForm.Type=='1'?$t('base.phoneNumberText'):$t('base.email')" autocomplete="off"></el-input>
        </el-form-item>
        <div class="code_box">
          <el-form-item class="login_form_item" prop="Code">
            <el-input class="login_ipt" v-model="ruleForm.Code" minlength='6' maxlength='6' :placeholder="$t('rules.enterCode')" :validate-event="false"></el-input>
          </el-form-item>
          <div class="code text_blue" v-if="isCode" @click="ruleForm.Account?getCode('ruleForm'):''" :class="!ruleForm.Account?'noemail':''"><span>{{$t('base.verify')}}</span></div>
          <div class="code Resend" v-if="!isCode"><span>{{$t('base.resendIn')}} {{ times }}s</span></div>
        </div>
      </el-form>
      <div class="btnBox">
        <el-button type="primary" class="primary" :disabled="disabled" @click="submitForm('ruleForm')">{{$t('base.next')}}</el-button>
      </div>
      <div class="isIframe" v-if="isIframe">
        <span class="closeSpan" @click="isIframe=false">X</span>
        <iframe id="ifcheckbox" :src="url" name="check" class="check_box" scrolling="no"></iframe>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { addressList, setInfo, throttle, postMessage } from "@/api/public";
import qs from 'qs'
export default {
  name: '',
  data() {
    var userValidate = (rule, value, callback) => {
      var msg = this.$t('rules.invalidPhone')
      if (this.smsMsg) {
        msg = this.smsMsg
        this.smsMsg = ""
        callback(new Error(msg));
      } else if (value === '') {
        if (this.ruleForm.Type == '0') {
          msg = this.$t('rules.invalidEmailAgain')
        }
        callback(new Error(msg));
      } else if (value != '') {
        if (this.ruleForm.Type == '0') {
          let reg = /^\w+@\w+(\.\w+)+$/;
          if (reg.test(value)) {
            callback();
          } else {
            callback(new Error(this.$t('rules.invalidEmailAgain')));
          }
        } else {
          // 验证 美国，香港，澳门，台湾 手机号位数 香港，澳门 为8位，美国，台湾为10位，台湾第二位必定是9
          let reg = /^\d{6,}$/;
          if (this.ruleForm.MemberSource == 'HK' || this.ruleForm.MemberSource == 'MO') {
            // 香港 澳门
            reg = /^\d{8}$/;
          }
          if (this.ruleForm.MemberSource == 'US' || this.ruleForm.MemberSource == 'TWN') {
            // 美国 台湾
            reg = /^\d{10}$/;
          }
          if (reg.test(value)) {
            // 台湾
            if (this.ruleForm.MemberSource == 'TWN') {
              if (value.substring(1, 2) != '9') {
                callback(new Error(msg));
              }
              callback();
            }
            callback();
          } else {
            callback(new Error(msg));
          }
        }
      } else {
        callback();
      }
    };
    return {
      locationOption: '', // 国家列表
      url: process.env.VUE_APP_CMS + '/checkcode/index?mobile=', // 图片验证
      isIframe: false, // 图片验证
      ruleForm: {
        Account: '',
        Code: '',
        Type: 1, //登录类型 0邮箱 1手机号
        AreaCode: '+1',
        MemberId: ''
      },
      rules: {
        Account: [
          { validator: userValidate, trigger: 'blur' },
        ],
        Code: [
          { required: true, message: this.$t('rules.invalidCodeAgain'), trigger: 'blur' },
        ]
      },
      checkbox: false, //修改手机弹框
      smsMsg: '',
      loading: false,
      disabled: false, // 按钮禁用
      times: 120, // 默认倒计时120秒
      isCode: true, // 判断是否已在倒计时
    }
  },
  props: {
    dialogClass: '',
    title: "",
    domVisible: Boolean,
    type: String,
    userInfo: {}
  },
  watch: {},
  filters: {},
  created() {
    this.ruleForm.Type = this.type
    this.ruleForm.MemberId = this.userInfo.Id
    this.getNationIcons()
  },
  mounted() {
    let that = this
    window.addEventListener("message", function(e) {
      //console.log(e)
      if (e.data == "checkcode") {
        that.getCodeOk()
        console.log(e)
      }
    });
    //window.addEventListener( 'message', this.scrollHander)
  },
  methods: {
    // 修改国家
    changeLocation(e) {
      let that = this
      that.locationOption.map(res => {
        if (res.Code == e) {
          that.ruleForm.MemberSource = res.Code //
          that.ruleForm.LocationIcon = res.IconUrl
          that.ruleForm.LocationName = res.EnName
          that.ruleForm.AreaCode = res.NationCode
        }
      })
      console.log(that.ruleForm)
    },
    //获取全部国家图标地址
    getNationIcons() {
      let that = this
      this.$get(this.$interface.GetAllNationIcons, '').then(res => {
        if (res.Result != 0) {
          that.locationOption = res.Data
          that.ruleForm.MemberSource = res.Data[0].Code //
          that.ruleForm.LocationIcon = res.Data[0].IconUrl
          that.ruleForm.LocationName = res.Data[0].EnName
          that.ruleForm.AreaCode = res.Data[0].NationCode
        }
      })
    },
    handleClose(val) {
      this.$emit('closeDialog', 'changePhone', false, val)
    },
    // 获取验证码
    getCode(formName) {
      let that = this
      that.smsMsg = ""
      // 获取验证码
      this.$refs[formName].validateField('Account', (val) => {
        if (val == "") {
          if (that.ruleForm.Type == 1) {
            // 手机获取验证码
            that.url = that.url + that.ruleForm.Account + '&lang=en'
            that.isIframe = true;
            // 开始监听
          } else {
            console.log(1231231)
            // 邮箱获取验证码
            this.getCodeOk()
          }
        }
      });

    },
    getCodeOk() {
      let that = this;
      that.isIframe = false;
      that.isCode = false;
      that.smsMsg = ""
      that.timer = setInterval(() => {
        that.times--;
        if (that.times === 0) {
          clearInterval(that.timer)
          that.times = 120;
          that.isCode = true;
        }
      }, 1000)
      var data = { 'email': that.ruleForm.Account, "type": 2, 'MemberId': that.userInfo.Id }
      var url = that.$interface.GetCodeEmail
      if (that.type == 1) {
        // 获取手机验证码
        data = { 'TelPhone': that.ruleForm.Account, 'Type': 2, 'NationCode': that.ruleForm.AreaCode, 'MemberId': that.userInfo.Id }
        url = that.$interface.GetCode
      }
      this.$post(url, data).then(res => {
        if (res.Result != 0) {
          that.disabled = false;
        } else {
          clearInterval(that.timer)
          that.times = 120;
          that.isCode = true;
          that.smsMsg = res.Msg
          that.$refs['ruleForm'].validateField("Account");
        }
      })
    },
    submitForm(formName) {

      let that = this;
      that.smsMsg = ""
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!that.checkbox && that.ruleForm.Type == 1) {
            this.$alert(`<div style="padding: 0 24px;">` + that.$t('alert.noEditPhone') + `</div>`, that.$t('base.hint'), {
              // showConfirmButton: true ,
              dangerouslyUseHTMLString: true,
              confirmButtonText: that.$t('base.know'),
              lockScroll: false,
              //cancelButtonText: 'Know',
              callback: action => {
                that.checkbox = true;
                that.submitForm('ruleForm')
              }
            })
          } else {
            that.ruleForm.MemberId = that.userInfo.Id;
            that.disabled = true;
            that.loading = true;
            let data = that.ruleForm
            let url = that.$interface.GetBindAccount
            that.$post(url, data).then(res => {
              if (res.Result != 0) {
                if (that.ruleForm.Type == 1) {
                  setInfo('TelPhone', data.Account)
                }
                this.handleClose(1)
              } else {
                that.$message({
                  type: 'error',
                  duration: 1000,
                  message: res.Msg
                });
                that.disabled = false;
              }
              that.loading = false;
            })
          }
        }
      })
    },
    removeListener() {
      // 删除监听
      this.isIframe = false;
      window.removeEventListener('message', function(e) {});

    }
  },
  beforeDestroy() {
    this.removeListener()
    this.handleClose()
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/login.css";

.accountBox {
  width: 360px;
  margin: 20px auto 0;
}

.AreaCode {
  width: 48px;
  height: 40px;
  text-align: center;
  margin-right: 12px;
  background-color: #F7F7F7;
  color: #a0a0a0;
  border-radius: 4px;
}

.btnBox {
  display: flex;
  justify-content: flex-end;
}

.primary {
  padding: 0;
  width: 49px;
  height: 32px;
  cursor: pointer;
  color: #fff;
  background-color: #5F6DAE;
  border-radius: 4px;
  line-height: 32px;
  text-align: center;
}

.isIframe {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, .5);
}

#ifcheckbox {
  border: none;
  width: 100%;
  height: 210px;
}

/deep/.account .el-form-item__content {
  display: flex;
}

.login_form_item .login_ipt.email {
  width: calc(360px - 106px);
  margin-top: 0;
  margin-left: 106px;
}

/deep/ .el-select.nolocation .el-input__inner {
  height: 40px;
}

/deep/ .login_form_item .login_ipt.email input {
  padding-left: 15px;
}

.isIframe .closeSpan {
  position: absolute;
  color: #fff;
  top: 21px;
  right: 23px;
  cursor: pointer;
}

.locationPhoneBox {
  top: -16px;
}

</style>



// WEBPACK FOOTER //
// src/components/dialog/changePhone.vue